<template>
<div class="text-left">
  <h1>Custom CSS</h1>
  <!-- bidirectional data binding（双向数据绑定） -->
  <codemirror v-model="formCSS" :options="cmOptions" @input="onCmCodeChange"></codemirror>

  
</div>

</template>

<script>
import { mapActions} from "vuex";
// language js
import 'codemirror/mode/javascript/javascript.js'
// theme css
import 'codemirror/theme/base16-dark.css'
// more codemirror resources
// import 'codemirror/some-resource...'
export default {
  name:"FormCssContainer",
  data () {
    return {
      formCSS: '// Add custom CSS',
      cmOptions: {
        // codemirror options
        tabSize: 4,
        mode: 'Text/Css',
        theme: 'Paraiso-Light',
        lineNumbers: true,
        line: true,
        height:500
        
      }
    }
  },
  methods: {
    ...mapActions(["updateFormCSS"]),
    onCmReady(cm) {
      // console.log('the editor is readied!', cm)
    },
    onCmFocus(cm) {
      // console.log('the editor is focus!', cm)
    },
    onCmCodeChange(newCode) {
      // console.log('this is new code', newCode)
      this.formCSS = newCode;
      this.updateFormCSS(this.formCSS);
      
    }
  },
  computed: {
  
    codemirror() {
      return this.$refs.myCm.codemirror
    }
  },
  mounted() {
    //// console.log('this is current codemirror object', this.codemirror)
    // you can use this.codemirror to do something...
  }
}
</script>